module.exports = __webpack_public_path__ + "media/images/icon_star0-11a1768dcdba212a19ed3a7242bf3234.svg";